export default __webpack_public_path__ + "static/services-image1-61242db3c69aea0f26bfd32ca13997f7.jpg";